// extracted by mini-css-extract-plugin
module.exports = {"disclaimerCon":"index_disclaimerCon__D0624","disclaimerConMobile":"index_disclaimerConMobile__3bN2T"};